<template>
    <div>
        <h4 class="mt-5">Use our Favlet</h4>
        <p>
            Drag this onto your Bookmark Bar =&gt; <a :href="script" class="btn btn-outline- favlet">Post on Pimlblr</a>
        </p>
        <p>
            Easily post on Pimblr using our Favelet!<br>
            Just drag the link above onto your Bookmark Bar and share videos
            with just two clicks.
        </p>
        <p>
            <img src="../../../static/favlet.gif" class="img-fluid rounded">
        </p>
    </div>
</template>

<script>
    export default {
        computed:{
            script() {
                let str = "javascript:var pimblrShare = ";
                str+= "window.open('";
                str+= document.location.protocol+"//";
                str+= document.location.host+"/share?b='+";
                str+= "btoa(document.location.href)";
                str+= ",'pimblrShare','width=600,height=680'";
                str+= ");";
                return str;
            }
        }
    }

    /**
     *
     * Instapaper Example
     * javascript:function%20iprl5(){var%20d=document,z=d.createElement('scr'+'ipt'),b=d.body,l=d.location;try{if(!b)throw(0);d.title='(Saving...)%20'+d.title;z.setAttribute('src',l.protocol+'//www.instapaper.com/j/VERYZ5TQuv4w?a=read-later&u='+encodeURIComponent(l.href)+'&t='+(new%20Date().getTime()));b.appendChild(z);}catch(e){alert('Please%20wait%20until%20the%20page%20has%20loaded.');}}iprl5();void(0)
     *
     */

</script>

<style lang="sass" scoped>
    .favlet
        border: 1px solid #CCC
        background-color: #F2F2F2
        color: #1b1e21

        &:hover
            opacity: .8
</style>


// WEBPACK FOOTER //
// src/components/ui/ShareBookmarklet.vue